import { config } from '../../config/config.js';
import { routing } from '../routing';

/*
    Function takes 'taxonomyTypes' as an array of objects:

        [
            {
                id: 1
                terms: [2]
            },
            {
                id: 2
                terms: [3,4]
            }
        ]

    and 'offset' as an integer
*/
export async function readFilteredPages(filtersString, offset, titleFilter) {

    const response = await fetch(config.url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                query {
                    readFilteredPages (
                        limit: ` + config.limit + `,
                        offset: ` + offset + `,
                        parentIDFilter: ` + config.pageId + `,
                        taxonomyTypes: ` + filtersString + `,
                        titleFilter: "` + titleFilter + `",
                        versioning: { mode: ` + routing.getReadingModeFromUrl() + ` }
                    )
                    {
                        nodes {
                            id
                            title
                            content
                            link
                            ... on PageInterface {
                                link
                                className
                            }
                            ... on TutorialPage {
                                image {
                                    id,
                                    title,
                                    listImageURL
                                }
                                masterOurCutsImageURL
                                summary

                            }
                            ... on ArticlePage {
                                image {
                                    id,
                                    title,
                                    listImageURL
                                }
                                masterOurCutsImageURL
                                summary
                            }
                            ... on RecipePage {
                                image {
                                    id,
                                    title,
                                    listImageURL
                                }
                                masterOurCutsImageURL
                                summary
                            }
                        }
                        pageInfo {
                            totalCount
                            hasNextPage
                            hasPreviousPage
                        }
                    }
                }
            `,
        }),
    });

    const json = await response.json();

    if (json.data && json.data.readFilteredPages) {

        return json.data.readFilteredPages;

    }

    return false;

}
